/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { InstallatoerDto as OkEgisServiceModelsDtoInstallatoerDto } from '../models/OK/Egis/Service/Models/DTO/installatoer-dto';
import { GetInstallatoererRequest as OkEgisServiceModelsRequestGetInstallatoererRequest } from '../models/OK/Egis/Service/Models/Request/get-installatoerer-request';
import { InstallatoerRequest as OkEgisServiceModelsRequestInstallatoerRequest } from '../models/OK/Egis/Service/Models/Request/installatoer-request';

@Injectable({
  providedIn: 'root',
})
export class InstallatoerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getInstallatoerer
   */
  static readonly GetInstallatoererPath = '/api/v1/Installatoer';

  /**
   * Returns a list of installatører.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInstallatoerer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getInstallatoerer$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetInstallatoererRequest
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoInstallatoerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, InstallatoerService.GetInstallatoererPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoInstallatoerDto>>;
      })
    );
  }

  /**
   * Returns a list of installatører.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInstallatoerer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getInstallatoerer(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetInstallatoererRequest
  }): Observable<Array<OkEgisServiceModelsDtoInstallatoerDto>> {

    return this.getInstallatoerer$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoInstallatoerDto>>) => r.body as Array<OkEgisServiceModelsDtoInstallatoerDto>)
    );
  }

  /**
   * Path part for operation addInstallatoer
   */
  static readonly AddInstallatoerPath = '/api/v1/Installatoer/AddInstallatoer';

  /**
   * Adds a henviser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addInstallatoer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInstallatoer$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestInstallatoerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoInstallatoerDto>> {

    const rb = new RequestBuilder(this.rootUrl, InstallatoerService.AddInstallatoerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoInstallatoerDto>;
      })
    );
  }

  /**
   * Adds a henviser.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addInstallatoer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addInstallatoer(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestInstallatoerRequest
  }): Observable<OkEgisServiceModelsDtoInstallatoerDto> {

    return this.addInstallatoer$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoInstallatoerDto>) => r.body as OkEgisServiceModelsDtoInstallatoerDto)
    );
  }

  /**
   * Path part for operation updateInstallatoer
   */
  static readonly UpdateInstallatoerPath = '/api/v1/Installatoer/UpdateInstallatoer';

  /**
   * Updates a henviser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInstallatoer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInstallatoer$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestInstallatoerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoInstallatoerDto>> {

    const rb = new RequestBuilder(this.rootUrl, InstallatoerService.UpdateInstallatoerPath, 'put');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoInstallatoerDto>;
      })
    );
  }

  /**
   * Updates a henviser.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateInstallatoer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInstallatoer(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestInstallatoerRequest
  }): Observable<OkEgisServiceModelsDtoInstallatoerDto> {

    return this.updateInstallatoer$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoInstallatoerDto>) => r.body as OkEgisServiceModelsDtoInstallatoerDto)
    );
  }

  /**
   * Path part for operation removeInstallatoer
   */
  static readonly RemoveInstallatoerPath = '/api/v1/Installatoer/RemoveInstallatoer';

  /**
   * Deletes a henviser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeInstallatoer()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeInstallatoer$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InstallatoerService.RemoveInstallatoerPath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deletes a henviser.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeInstallatoer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeInstallatoer(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.removeInstallatoer$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
